import { render, staticRenderFns } from "./addSlider.vue?vue&type=template&id=92917200"
import script from "./addSlider.vue?vue&type=script&lang=js"
export * from "./addSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports